var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ContentService } from '@app/shared/services/content.service';
import { select, Store } from '@ngrx/store';
import * as fromGis from '@gis/reducers/index';
import { map } from 'rxjs/operators';
import * as esri from 'esri-leaflet';
import { getGisToken } from '@app/modules/gis/gis-token';
import { MapLayerActions } from '@app/modules/gis/actions';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app-config.service";
import * as i3 from "./content.service";
import * as i4 from "@ngrx/store";
var AnalogService = /** @class */ (function () {
    function AnalogService(http, _appConfig, content, store) {
        var _this = this;
        this.http = http;
        this._appConfig = _appConfig;
        this.content = content;
        this.store = store;
        this.basinConfig = {};
        this.clickedBasin = new BehaviorSubject(0);
        this.unclickedBasin = new BehaviorSubject(0);
        this.hover = new BehaviorSubject(0);
        this.unhover = new BehaviorSubject(0);
        this.colorPool = [];
        this.features = new BehaviorSubject([]);
        this.configs = [];
        this.subscriptions = [];
        var config = this._appConfig.getConfig();
        this.API_PATH = config.datascience_api_baseurl + '/analogs';
        this.spiderChartData = [];
        this.colorIndex = -1;
        this.colorPool = this.content.local.SPIDER_CHART.COLOR_POOL;
        var $getAOILayerConfigSubscribe = this.store.pipe(select(fromGis.getAOILayerConfig), map(function (configs) { return configs.basin; }))
            .subscribe(function (configs) { return _this.configs = configs; });
        this.subscriptions.push($getAOILayerConfigSubscribe);
    }
    AnalogService.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (subscription) {
            try {
                subscription.unsubscribe();
            }
            catch (e) {
                console.error('[Error] OnDestroy unsubscribes', e);
            }
        });
    };
    AnalogService.prototype.getColor = function () {
        this.colorIndex = this.colorIndex >= this.colorPool.length ? 0 : this.colorIndex;
        return this.colorPool[this.colorIndex++];
    };
    AnalogService.prototype.colorIndexRestart = function () {
        this.colorIndex = -1;
    };
    AnalogService.prototype.getBasins = function () {
        return this.http.get(this.API_PATH + "/getBasins");
        // return this.http.get<any[]>(`/assets/data/analog_get_basins.json`);
    };
    AnalogService.prototype.getKeywords = function () {
        return this.http.get(this.API_PATH + "/getKeywords");
        // return this.http.get<any[]>(`/assets/data/analog_get_keywords.json`);
    };
    AnalogService.prototype.findSimilar = function (basin) {
        return this.http.get(this.API_PATH + "/findSimilar?basin=" + basin);
        // return this.http.get<any[]>(`/assets/data/analog_find_similar.json`);
    };
    AnalogService.prototype.getAnalogs = function (basin) {
        return this.http.get(this.API_PATH + "/getAnalogs?basin=" + basin);
        // return this.http.get<any[]>(`/assets/data/analog_get_analogs.json`);
    };
    AnalogService.prototype.getEvidenceBreakout = function (basins, lithology) {
        return this.http.get(this.API_PATH + "/getEvidenceBreakout?basins=" + basins.join(',') + "&&keyword=" + lithology);
        // return this.http.get<any[]>(`/assets/data/analog_get_evidence_breakou.json`);
    };
    AnalogService.prototype.SetBasinConfig = function (config) {
        this.store.dispatch(new MapLayerActions.SetMapLoading(true));
        this.SetFeatures([]);
        if (config.basin && config.basinCollection && config.basinCollection.length > 0) {
            if (this.configs) {
                for (var i = 0; i < this.configs.length; i++) {
                    this.basinConfig = config;
                    this.queryFeatures(this.configs[i], config.basinCollection);
                }
            }
        }
    };
    AnalogService.prototype.queryFeatures = function (config, basins) {
        return __awaiter(this, void 0, void 0, function () {
            var condition, token, query;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        condition = config.attribute + " IN (" + basins.map(function (basin) { return "'" + basin + "'"; }).join(',') + ")";
                        return [4 /*yield*/, getGisToken()];
                    case 1:
                        token = _a.sent();
                        query = esri.query({
                            url: config.url,
                            useCors: true,
                            withCredentials: true,
                            token: token
                        });
                        query.where(condition);
                        query.run(function (error, featureCollection) {
                            if (error) {
                            }
                            else {
                                var result = {};
                                if (featureCollection.features.length > 0) {
                                    result = featureCollection.features;
                                }
                                _this.SetFeatures(result);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AnalogService.prototype.SetClickedBasin = function (index) {
        this.clickedBasin.next(index);
    };
    AnalogService.prototype.SetUnclickedBasin = function (index) {
        this.unclickedBasin.next(index);
    };
    AnalogService.prototype.SetHover = function (index) {
        this.hover.next(index);
    };
    AnalogService.prototype.SetUnhover = function (index) {
        this.unhover.next(index);
    };
    AnalogService.prototype.SetSpiderChartData = function (spiderChartData) {
        this.spiderChartData = spiderChartData;
    };
    AnalogService.prototype.SetFeatures = function (features) {
        this.features.next(features);
    };
    AnalogService.ngInjectableDef = i0.defineInjectable({ factory: function AnalogService_Factory() { return new AnalogService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfigService), i0.inject(i3.ContentService), i0.inject(i4.Store)); }, token: AnalogService, providedIn: "root" });
    return AnalogService;
}());
export { AnalogService };
